export interface IFilterQueryParams {
  checkedFilters: IFilter[];
  sorter?: IQuerySorter;
  page: number;
  applyFilterGroupCount?: IFacetGroupCount;
  searchString: string;
}

export interface IUpdatePageParams {
  responseData: any;
  replaceProducts: boolean;
  filterQuerySelector: string;
  pagingQuerySelector: string;
  itemsQuerySelector: string;
  sortersQuerySelector: string;
  selectedFiltersQuerySelector: string;
}

export interface IFacetGroupCount {
  key: string;
  valueCountData: IFacetValueCount[];
}

export interface IFacetValueCount {
  value: string;
  count: number;
}

export interface IFilter {
  key: string;
  operator: FilterOperator;
  values: string[];
}

export interface IQuerySorter {
  key: string;
  sortDirection: number;
}

export interface ISorter {
  key: string;
  sortDirection: string;
}

export interface IFilterElementState {
  elementId: string;
  stateType: FilterStateType;
  value: any;
}

export enum FilterStateType {
  Scroll,
  Open,
}

export enum FilterOperator {
  Equal,
  NotEqual,
  GreaterThan,
  LessThan,
}

export enum FilterFor {
  Category,
  Brand,
  Search,
  Articles,
  Orders,
  Subscription,
}
